var map = {
	"./heading-forest.svg": "epoP",
	"./heading-ocean.svg": "toL/",
	"./heading-prize.svg": "b6TW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YPOB";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/heading\-.*\.svg$
// module id = YPOB
// module chunks = 1